// Module
var code = "<h1 class=\"heading--isInteriorPageSubHeadingLeft\"> Loan Forgiveness and Discharge </h1> <p>See if you qualify to have your loan debt reduced or eliminated, depending on your professional or personal situation. </p> ";
// Exports
export default code;